(() => {
  'use strict';
  if (customElements.get('iurop-set-offer')) return;

  class SetOffer extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.templates = Array.from(this.querySelectorAll('template[data-set-variant]'));
      this.options = Array.from(this.querySelectorAll('[data-set-option]'));
      this.content = this.querySelector('[data-set-content]');
      this.button = this.querySelector('[data-set-add]');
      this.status = this.querySelector('[data-set-status]');
      this.current = this.templates.find(t => t.dataset.setVariant === this.dataset.selectedId);
      if (!this.current) return;
      const controls = this.querySelector('[data-set-controls]');
      if (controls) controls.hidden = false;
      const selected = JSON.parse(this.current.dataset.options);
      this.options.forEach((select, index) => {
        select.value = selected[index];
        select.addEventListener('change', () => this.selectOptions(), { signal });
      });
      if (this.hasAttribute('data-set-self')) {
        this.closest('[data-product-section]')?.addEventListener('product:variant-change', event => {
          const match = this.templates.find(t => t.dataset.setVariant === String(event.detail.variant?.id));
          this.renderVariant(match);
        }, { signal });
      }
      this.button?.addEventListener('click', () => this.add(), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    selectOptions() {
      const values = this.options.map(select => select.value);
      const match = this.templates.find(template => {
        const options = JSON.parse(template.dataset.options);
        return options.every((option, index) => option === values[index]);
      });
      this.renderVariant(match);
    }

    renderVariant(template) {
      this.current = template;
      this.content.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
      const available = template?.dataset.available === 'true';
      if (this.button) {
        this.button.disabled = !available || this.busy;
        this.button.textContent = available ? this.dataset.labelAdd : this.dataset.labelUnavailable;
      }
      if (this.status) this.status.textContent = template ? '' : this.dataset.labelUnavailable;
    }

    async add() {
      if (this.busy || this.current?.dataset.available !== 'true') return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.options.forEach(select => { select.disabled = true; });
      this.status.textContent = '';
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.current.dataset.setVariant), quantity: 1 }] }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.labelError);
        this.status.textContent = this.dataset.labelAdded;
        let cart;
        try {
          const cartResponse = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) cart = await cartResponse.json();
        } catch (_) {}
        if (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
            el.classList.toggle('visually-hidden', cart.item_count === 0);
          });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (error) {
        this.status.textContent = error.message || this.dataset.labelError;
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.button.disabled = this.current?.dataset.available !== 'true';
        this.options.forEach(select => { select.disabled = false; });
      }
    }
  }
  customElements.define('iurop-set-offer', SetOffer);
})();
